import { m8API } from 'services/production/m8';
import { UpdatePaymentExchangeRateService } from 'types/services';

export const updatePaymentExchangeRate: UpdatePaymentExchangeRateService = async (
  paymentId,
  m8RateDTO
) => {
  await m8API.admin.changeStatementRate({
    idStatement: paymentId,
    rateDate: m8RateDTO.dateOn,
  });
};
